export enum AdminBrandBannerListAction {
  Create = 'CREATE',
}
